var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentName,_vm._g({tag:"component",attrs:{"selected-country":_vm.selectedCountry,"clearable":_vm.clearable,"direction":_vm.direction,"data-test":_vm.dataTest}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }